import dayjs from 'dayjs';
import editCompanyFormModel from './editCompanyFormModel';
const {
  formField: {

    // DATOS BASICOS 
    e_type_document,
    e_number_document,
    e_tradename,
    e_business_name,
    e_legal_representative,
    e_email,
    e_manager_in_charge,
    e_economic_activity,
    e_branch_offices,
    e_country,
    e_departament,
    e_municipaly,
    e_address_company,
    e_workplace,
    e_landline,
    e_cell_phone,

    // FORMA DE PAGO 
    e_payment_frequency,
    e_payment_method,
    e_associated_bank,
    e_type_account_bank,
    e_account_number,

    // SEGURIDAD SOCIAL 
    e_sgsst,
    e_arl,
    e_constitution_date,
    e_ley_1429_2010,
    e_ley_590_2000,
    e_ley_1607_2012,

    // ARCHIVOS
    e_rut,
    e_rut_name_saved_file,
    e_chamber_of_commerce,
    e_chamber_of_commerce_name_saved_name,
    e_bank_certificate,
    e_bank_certificate_name_saved_name,


    // LOGOS NOMBRE COMERCIAL 
    e_logo_bn_company,
    e_logo_bn_company_name_saved_file,
    e_logo_bn_post_company,
    e_logo_bn_rz_post_company_name_saved_file,


    // LOGOS POST COMERCIAL 
    e_logo_rz_company,
    e_logo_post_rz_company
  } 
} = editCompanyFormModel;

export default {
  [e_arl.name]: '',
  [e_rut.name]: null,
  [e_landline.name]: '',
  [e_country.name]: '',
  [e_email.name]: '',
  [e_sgsst.name]: '',
  [e_branch_offices.name]: false,
  [e_workplace.name]: '',
  [e_tradename.name]: '',
  [e_municipaly.name]: '',
  [e_departament.name]: '',
  [e_cell_phone.name]: '',
  [e_economic_activity.name]: '',
  [e_payment_method.name]: '',
  [e_associated_bank.name]: '',
  [e_type_document.name]: '',
  [e_legal_representative.name]: '',
  [e_business_name.name]: '',
  [e_manager_in_charge.name]: '',
  [e_address_company.name]: '',
  [e_payment_frequency.name]: '',
  [e_type_account_bank.name]: '',
  [e_account_number.name]: '',
  [e_constitution_date.name]: null,
  [e_ley_590_2000.name]: false,
  [e_ley_1607_2012.name]: false,
  [e_ley_1429_2010.name]: false,
  [e_rut_name_saved_file.name]: null,
  [e_logo_rz_company.name]: null,
  [e_logo_post_rz_company.name]: null,
  [e_bank_certificate.name]: null,
  [e_logo_bn_company.name]: null,
  [e_logo_bn_post_company.name]: null,
  [e_chamber_of_commerce.name]: null,
  [e_bank_certificate_name_saved_name.name]: null,
  [e_logo_bn_company_name_saved_file.name]: null,
  [e_logo_bn_rz_post_company_name_saved_file.name]: null,
  [e_chamber_of_commerce_name_saved_name.name]: null,
  [e_number_document.name]: '',
};

